/**
 * @desc 查看报警消息详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertMessageInfoResponse>> {
  return defHttp.get({
    url: '/wap/alert/message/getAlertMessage',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertMessageInfoResponse>> {
  return defHttp.get({
    url: '/mock/wap/alert/message/getAlertMessage',

    params,
  });
}
